/**
 * API接口描述页面
 * 显示后端所有接口的详细信息
 */
import React, { useState, useMemo } from "react";
import { CompsApiList, CompsApiDetail } from "@ms/shared-components";
import type { ApiGroup, ApiCategoryGroup } from "@ms/shared-components/comps/CompsApiList";
import type { ApiDetail } from "@ms/shared-components/comps/CompsApiDetail";
import { API_ENDPOINTS, getAllCategories, getApisByCategory, getCategoryGroups } from "./config";

const ApiDocsPage: React.FC = () => {
  // 选中的接口ID
  const [selectedApiId, setSelectedApiId] = useState<string>(API_ENDPOINTS[0]?.id);

  // 选中的接口详情
  const selectedApi = useMemo(() => {
    return API_ENDPOINTS.find((api) => api.id === selectedApiId);
  }, [selectedApiId]);

  // 按一级分类分组的接口列表（可折叠）
  const categoryGroups: ApiCategoryGroup[] = useMemo(() => {
    return getCategoryGroups();
  }, []);

  // 按分类分组的接口列表（向后兼容，不使用一级分类时使用）
  const groupedApis: ApiGroup[] = useMemo(() => {
    const categories = getAllCategories();
    return categories.map((category) => ({
      category,
      apis: getApisByCategory(category).map((api) => ({
        id: api.id,
        method: api.method,
        name: api.name,
        path: api.path,
      })),
    }));
  }, []);

  // 转换接口详情格式
  const apiDetail: ApiDetail | undefined = useMemo(() => {
    if (!selectedApi) return undefined;

    return {
      id: selectedApi.id,
      method: selectedApi.method,
      name: selectedApi.name,
      description: selectedApi.description,
      path: selectedApi.path,
      requiredPermission: selectedApi.requiredPermission,
      pathParams: selectedApi.pathParams,
      queryParams: selectedApi.queryParams,
      bodyParams: selectedApi.bodyParams,
      responseFields: selectedApi.responseFields,
      responseExample: selectedApi.responseExample,
    };
  }, [selectedApi]);

  return (
    <div style={{ display: "flex", gap: "16px", height: "calc(100vh - 120px)" }}>
      {/* 左侧接口列表 */}
      <CompsApiList categoryGroups={categoryGroups} selectedId={selectedApiId} onSelect={setSelectedApiId} />

      {/* 右侧接口详情 */}
      <CompsApiDetail api={apiDetail} />
    </div>
  );
};

export default ApiDocsPage;
